import { type ReactNode, useEffect, useMemo, useReducer } from 'react';
import { type ReducerState, INITIAL_REDUCER_STATE, reducer } from './reducer';
import { type WidgetMessageAction, type Culture, connectWidget } from './widgetMessages';
import CommunicationContext from './CommunicationContext';

type Props = { children: ReactNode };

const CommunicationProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_REDUCER_STATE);

  const value = useMemo(() => isReady(state) ? {
    userAccessToken: state.userAccessToken,
    culture: state.culture,
  } : null, [state]);

  useEffect(() => {
    const channel = new MessageChannel();

    channel.port1.onmessage = (e: MessageEvent<WidgetMessageAction>) => dispatch(e.data);
    window.parent.postMessage(
      connectWidget(),
      document.referrer ? new URL(document.referrer).origin : '*',
      [channel.port2],
    );

    return () => {
      channel.port1.close();
      channel.port2.close();
    };
  }, []);

  return <CommunicationContext.Provider value={value}>{children}</CommunicationContext.Provider>;
};

export default CommunicationProvider;

type ReadyState = ReducerState & {
  isConnected: true;
  userAccessToken: string;
  culture: Culture;
};

function isReady(state: ReducerState): state is ReadyState {
  return state.isConnected && !!state.userAccessToken && !!state.culture;
}
